import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * Invite modal — shown when the scorecard first loads so the host can
 * share the session with friends. Shows:
 *   • Session code in large text
 *   • QR code that encodes https://pubgolfgame.com/join?code=CODE
 *   • Copy Link button
 *   • Native Share button (Web Share API)
 *
 * `autoShow` controls whether the modal opens once per session on mount
 * (the scorecard uses this to show it automatically when a fresh round
 * starts).
 */
export default function InviteModal({ code, onClose }) {
  const [copied, setCopied] = useState(false);
  const joinUrl = `https://pubgolfgame.com/join?code=${encodeURIComponent(code)}`;
  const shareText = `Join my Pub Golf round — code ${code}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(joinUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {}
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Pub Golf',
          text: shareText,
          url: joinUrl,
        });
      } catch {}
    } else {
      copyLink();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-sheet invite-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="invite-modal-close"
          onClick={onClose}
          aria-label="Close"
          type="button"
        >
          ✕
        </button>

        <div className="invite-modal-header">
          <div className="u-label">Invite Players</div>
          <h2>Scan to join</h2>
          <p className="text-muted">
            Have friends point their camera at the code or enter{' '}
            <strong>{code}</strong> manually.
          </p>
        </div>

        <div className="invite-qr-wrap">
          <div className="invite-qr">
            <QRCodeSVG
              value={joinUrl}
              size={200}
              level="M"
              marginSize={2}
              bgColor="#ffffff"
              fgColor="#1f1a12"
            />
          </div>
          <div className="invite-code">{code}</div>
          <div className="invite-url">pubgolfgame.com/join</div>
        </div>

        <div className="invite-actions">
          <button
            className="btn btn-ghost btn-block"
            onClick={copyLink}
          >
            {copied ? '✓ Copied' : '🔗 Copy Link'}
          </button>
          {navigator.share && (
            <button className="btn btn-primary btn-block" onClick={nativeShare}>
              ⇪ Share
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
